module.exports = __webpack_public_path__ + "media/images/talent/mv-slider01-ba10ee25ccd9fa4fbbd49f540e0e5526.png";